/* eslint-disable @nx/enforce-module-boundaries */
import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';
import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterOutlet,
} from '@angular/router';
import { SimpleProgressBarComponent } from './components/simple-progress-bar/simple-progress-bar.component';
import { SkeletonLoaderComponent } from './components/skeleton-loader/skeleton-loader.component';
import { OrbitFormClaimService } from './services/orbit-form-claim.service';
import { ButtonComponent } from './components/button/button.component';
import { getRoute } from './statics/steps-route-mapping';
import { take } from 'rxjs';
import { ClaimSteps } from './statics/claim-steps.enum';

@Component({
  selector: 'lib-orbit-claims-component',
  standalone: true,
  imports: [
    RouterOutlet,
    ButtonComponent,
    SkeletonLoaderComponent,
    CommonModule,
    SimpleProgressBarComponent,
    RouterLink,
  ],
  templateUrl: './orbit-claims.component.html',
  styleUrl: './orbit-claims.component.scss',
})
export class OrbitClaimComponent implements OnInit {
  constructor() {
    const { bundle } = this.route.snapshot.queryParams;
    if (bundle) {
      sessionStorage.setItem('currentClaim', bundle);
    }
    this.orbitClaimService
      .inspectBundle(sessionStorage.getItem('currentClaim'))
      .pipe(take(1))
      .subscribe((val: any) => {
        this.router.navigate([
          'orbit',
          this.route.snapshot.params['planNumber'],
          getRoute(this.calculateFirstStep(val.stepsToGoThrough)),
        ]);
      });
  }

  brand = signal<string>('');
  appliance = signal<string>('');
  planNumber = signal<string>('');
  route = inject(ActivatedRoute);
  router = inject(Router);
  orbitClaimService = inject(OrbitFormClaimService);
  currentStep = signal<any | undefined>(undefined);
  formValid = signal(false);
  protected formValue = signal<Partial<Record<string, any>>>({});
  stageSubmitted = signal<boolean>(false);
  formSubmitted = input.required<boolean>();
  loadingData = signal<boolean>(false);
  error = signal<string>('');

  showSummaryPanel = signal(false);

  get continueTitle(): string {
    return this.orbitClaimService.state.stillCantFindNumber
      ? 'Continue anyway'
      : 'Continue';
  }

  ngOnInit(): void {
    this.planNumber.set(this.route.snapshot.params['planNumber']);
    this.orbitClaimService.loadPlanClaims(this.planNumber());
  }

  calculateFirstStep(steps: string[]) {
    if (steps.includes('model-number')) {
      return ClaimSteps.CaptureModelNumber;
    } else if (steps.includes('fault-details')) {
      return ClaimSteps.FaultCapture;
    }
    return ClaimSteps.CaptureModelNumber;
  }

  private viewModel = computed(() => {
    const { plan } = this.orbitClaimService.plan() || { plan: undefined };
    return {
      titleDetails:
        plan != undefined
          ? `${plan?.item?.manufacturer} ${plan?.item?.code_description}`
          : '',
      mmrPageLink: ['/', 'my-plans', this.planNumber(), 'claims'],
      showSummaryPanel: this.showSummaryPanel(),
      isLoading:
        plan === undefined ||
        this.orbitClaimService.state.claimData === undefined,
      percentage: this.orbitClaimService.state.percentage,
      plan: this.orbitClaimService.plan(),
      currentStep: this.currentStep(),
      formValid: this.formValid(),
      formValue: this.formValue(),
      loadingData: this.orbitClaimService.state.isLoading,
      error: this.error(),
    };
  });

  get vm() {
    return this.viewModel();
  }

  nextPage() {
    this.orbitClaimService.handleNextNav();
  }
}
